import { DataProviderBase, UIProviderBase } from '../../semantic';
import { AdmsAsset } from '../../redux';
import { subsetByLangOnly } from '../../virtuoso/helper'; 
import { Concepts, Concept, Foaf, vCard, Language, ExternalLink, AssetLink, DefaultValue, FileDownload} from './AssetWidgets'
import AdmsOntologyHelper from './AdmsOntologyHelper';
import EditLiteralForm from '../widgets/EditLiteral';
import EditObjectProperty from '../widgets/EditObjectProperty';

const ontology = new AdmsOntologyHelper();

/** Провайдер получения данных ADMS */
const default_graph ='http://csi.semanticpro.org/ADMS';

/** Описание данных ADMS и их получение из графовой БД. 
 * Определяет доступные типы */
export class AdmsDataProvider extends DataProviderBase {
  
  constructor(graph = default_graph) { 
    super(graph); 
  };

    /** Получить значение метки для IRI, полученного из triplet */
  getLabelByIRI = (IRI, lang=undefined, triplet=undefined) => dispatch =>{
    //console.log("getLabelByIRI", AdmsAsset);
    return dispatch(AdmsAsset.loadLabelByIRI(IRI))
      .then(response =>{
        const { head ,results } = response;
        const { bindings } = results;
        const labels = subsetByLangOnly(bindings, lang, "label");
        const label = (labels.length>0)? labels[0].label.value:(bindings && Array.isArray(bindings) && (bindings.length>0))?bindings[0].label.value:IRI;
        //console.log("getLabelByIRI!!!!", labels, label, bindings);
        return Promise.resolve({IRI, label: label, lang: lang});
      })
      .catch(e => { 
        return Promise.resolve({IRI, label: IRI, lang: lang, e});
      });
  }
 
  /** Если  rdfType равен undefined, то возвращается список всех свойств */
  getProperties(rdfType, purpose=undefined) {
    return ontology.getProperties(rdfType, purpose);
  }

  /** Возвращает true, если предикат определяет объетное свойства (т.е. ссылка) */
  isObjectProperty(predicat){
    return ontology.isObjectProperty(predicat);
  }

  /** Возвращает массив типов назначенных для свойства 
   * (см. значение для предиката http://www.w3.org/2000/01/rdf-schema#:range */
  getRanges(iriProperty){
    return ontology.getRanges(iriProperty);
  }
}


/** Провайдер, для получения визуальных компонент, их параметров, 
 * состава элементов визуализации. Например свойства, которые отображаются,
 * который можно редактирования, переводить и т.п.
 */
export class AdmsUIProvider extends UIProviderBase {
  
  constructor(graph = default_graph) { 
    super(graph); 
  };

  /** Получение компоненты для */
  getUIComponent = (predicat, operation="view", type=null) => { 
    //console.log("Providers.js getUIComponent", predicat, operation, type, ontology);
    if (operation=="edit"){
      if (ontology.isLiteralProperty(predicat)){
        return EditLiteralForm;
      }
      if (ontology.isObjectProperty(predicat)){
        return EditObjectProperty;
      }
    }
    if (["http://purl.org/dc/terms/creator", "http://www.w3.org/ns/dcat#contactPoint", 
      "http://purl.org/dc/terms/contributor"].includes(predicat)) return vCard;
    if ("http://purl.org/dc/terms/publisher" == predicat) return Foaf;
    if ("http://purl.org/dc/terms/language" == predicat) return Language;
    if (["http://www.w3.org/ns/dcat#landingPage", "http://www.w3.org/2007/05/powder-s#describedby",
      "http://www.w3.org/ns/dcat#accessURL", "http://xmlns.com/foaf/0.1/homepage"].includes(predicat)) return ExternalLink;
    if ("http://www.w3.org/ns/dcat#theme" == predicat) return Concepts;
    if ("http://csi.semanticpro.org/adms/wf/maturityLevel" == predicat) return Concept;
    if (["http://www.w3.org/1999/xhtml/vocab#last", "http://www.w3.org/ns/adms#next",
         "http://www.w3.org/ns/adms#prev", "http://www.w3.org/ns/adms#sample", "http://www.w3.org/ns/adms#translation",
         "http://csi.semanticpro.org/2016/ns#disjunction", "http://csi.semanticpro.org/2016/ns#equivalent",
         "http://csi.semanticpro.org/2016/ns#extend", "http://csi.semanticpro.org/2016/ns#generalize",
         "http://csi.semanticpro.org/2016/ns#import","http://csi.semanticpro.org/2016/ns#metadata",
         "http://csi.semanticpro.org/2016/ns#specialize", "http://csi.semanticpro.org/2016/ns#domain",
        ].includes(predicat)) return AssetLink;
    if ("http://www.w3.org/ns/dcat#downloadURL" == predicat) return FileDownload;
    return DefaultValue;
  };
}

/** Фабрика  */
class ProvidersFactory {
  constructor(){
      this._graph = default_graph;
      this._ui = new AdmsUIProvider();
      this._provider = new AdmsDataProvider();
  }

  get graph () { return this._graph; };
  set graph (graph) { this._graph = graph; this._provider = new AdmsDataProvider(graph); };

  get provider () { return this._provider; };
  set provider (provider) { this._provider = provider; };

  get ui () { return this._ui; };
  set ui (ui) { this._ui = ui; };
}

export const factory = new ProvidersFactory();